import type { TargetField } from "./types";

// Column names arrive slugged ("numero_de_serie"), labels are translated ("Numéro de série"):
// both are compared once stripped of case, accents and separators.
export const normalize = (value: string): string =>
  value.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");

/**
 * Builds a target field recognized by its name, its label and the given aliases.
 *
 * @param name the field key without what only tells its group apart (e.g. "serial_number")
 */
export const targetField = (
  key: string,
  label: string,
  group: string,
  inputName: string,
  aliases: string[] = [],
  name: string = key,
): TargetField => ({
  key,
  label,
  group,
  inputName,
  aliases: [...new Set([normalize(name), normalize(label), ...aliases].filter(Boolean))],
});
